import React, { Component } from 'react';
import { withRouter, } from 'react-router-dom';
import { queryAPI } from '../../api/news.js'
import '../../assets/css/common.css'
import MyBreadcrumb from '../../components/MyBreadcrumb.jsx'

class NewsDetail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currId: this.props.match.params.id ? this.props.match.params.id : '',
			currRecord: '',
		}
	}

	componentDidMount() {
		this.ajaxData()
	}

	// 获取资讯数据
	ajaxData = () => {
		queryAPI({ news_id: this.state.currId })
			.then(res => {
				var data = res.data.data
				data.create_time = data.create_time.split('T')[0]
				this.setState({ currRecord: data })
			})
	}

	render() {
		const { currRecord } = this.state;
		return (
			<div style={{ margin: '40px 18%', }}>
				<MyBreadcrumb urls={[
					{ url: '/news', breadcrumbName: '资讯' },
					{ breadcrumbName: '正文' },
				]} />
				<div className="major-heading" style={{ textAlign: 'center', marginBottom: 4 }}>{currRecord.title}</div>
				<div className="auxiliary-text" style={{ textAlign: 'center', marginBottom: 20, color: '#999999' }}>发布时间：{currRecord.create_time}</div>
				<div dangerouslySetInnerHTML={{ __html: currRecord.content }} style={{ marginBottom: 20 }}></div>
			</div>
		);
	}
}

export default withRouter(NewsDetail)
